var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2753_8536)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.9987 1.33337C4.3187 1.33337 1.33203 4.32004 1.33203 8.00004C1.33203 11.68 4.3187 14.6667 7.9987 14.6667C11.6787 14.6667 14.6654 11.68 14.6654 8.00004C14.6654 4.32004 11.6787 1.33337 7.9987 1.33337ZM7.9987 13.3334C5.0587 13.3334 2.66536 10.94 2.66536 8.00004C2.66536 5.06004 5.0587 2.66671 7.9987 2.66671C10.9387 2.66671 13.332 5.06004 13.332 8.00004C13.332 10.94 10.9387 13.3334 7.9987 13.3334ZM11.0587 5.05337L6.66536 9.44671L4.9387 7.72671L3.9987 8.66671L6.66536 11.3334L11.9987 6.00004L11.0587 5.05337Z",
    fill: "#13BF86"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2753_8536"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check_circle.3463e95eb098a37c3113d2f729b917e9.svg";
export { ForwardRef as ReactComponent };